import React, { useState, useEffect } from 'react';
import './Header.css'; // Import your CSS file
import logo from '../images/pandatoolboxblk.png'; // Import your logo
import logoHover from '../images/pandatoolbox.png'; // Import your hover logo

const Header = () => {
    const [index, setIndex] = useState(0);
    const [currentLogo, setCurrentLogo] = useState(logo);
    const sentences = ['Create tokens with ease', 'No coding required', 'Create the next big Meme coin'];

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % sentences.length);
        }, 2000); // Change sentence every 2 seconds

        return () => clearInterval(interval); // Clean up on unmount
    }, []);

    return (
        <header className="header">
            <img src={currentLogo} alt="Logo" 
                 onMouseEnter={() => setCurrentLogo(logoHover)} 
                 onMouseLeave={() => setCurrentLogo(logo)} /> {/* Use your logo */}
            <h1>{sentences[index]}</h1>
            <nav>
                <ul>
                <li><a href="https://github.com/panoptisDev">Github</a></li>
                <li><a href="/about">About</a></li>
                <li><a href="https://testnet.bscscan.com/address/0x080B0e08C1bc19E8B36565FCd753dF447501Be2e#code">Contract</a></li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;